import initForm from "./initForm.js";
import initCustomSelects from "./initCustomSelects.js";
import axios from 'axios';

const initFormsSubmit = () => {

    const getRecaptchaToken = async (action = 'form_submit') => {
        if (!window.grecaptcha || !window.recaptcha_site_key) {
            return null;
        }

        return new Promise((resolve) => {
            grecaptcha.ready(() => {
                grecaptcha.execute(window.recaptcha_site_key, { action })
                    .then(token => resolve(token))
                    .catch(() => resolve(null));
            });
        });
    };

    const { createCustomSelect, resetCustomSelects } = initCustomSelects();
    createCustomSelect();

    const { initFormInputs, renderFormErrors } = initForm();
    initFormInputs();

    const dialogSuccessElm = document.getElementById('dialog--success');
    const dialogErrorElm = document.getElementById('dialog--error');

    const formElms = document.querySelectorAll('.form__block');

    if (formElms && formElms.length) {
        formElms.forEach(formElm => {
            const formSubmitBtn = formElm.querySelector('[data-form-submit]');
            const formItemElms = formElm.querySelectorAll('.form__item');

            let debounceTimer = null;
            const DEBOUNCE_DELAY = 1000;

            const closeAllDialogs = () => {
                const parentDialog = formElm.closest('dialog');
                if (parentDialog) parentDialog.close();
            };

            const runSubmit = () => {
                formSubmitBtn?.classList.add('button--loading');
                handleFormSubmit();
            };

            formElm.addEventListener('submit', (e) => {
                e.preventDefault();
                clearTimeout(debounceTimer);
                formSubmitBtn.classList.add('button--loading');
                debounceTimer = setTimeout(runSubmit, DEBOUNCE_DELAY);
            });

            async function handleFormSubmit() {

                const formData = new FormData(formElm);

                const recaptchaToken = await getRecaptchaToken('form_submit');
                if (recaptchaToken) {
                    formData.append('recaptcha_token', recaptchaToken);
                }

                formElm.querySelectorAll('.input--phone-mask').forEach(input => {
                    const phone = input._phone;
                    if (!input.name || !phone) return;

                    const { iti, mask } = phone;

                    const isComplete = mask?.masked?.isComplete === true;

                    let isTooShort = false;
                    if (iti) {
                        const errorCode = iti.getValidationError?.();
                        isTooShort = errorCode === 2; // TOO_SHORT
                    }

                    const isMaskValid = isComplete && !isTooShort;

                    formData.set(`${input.name}_mask`, isMaskValid ? 'true' : 'false');

                    if (iti) {
                        const countryData = iti.getSelectedCountryData();
                        formData.set(
                            `${input.name}_country`,
                            JSON.stringify(countryData)
                        );
                    }
                });

                const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

                try {
                    const response = await axios.post(formElm.action, formData, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-CSRF-TOKEN': token,
                        },
                        withCredentials: true,
                    });
                    if (response && response.status === 200) {
                        closeAllDialogs();

                        setTimeout(() => {
                            if (response.data.success && response.data.redirect) {
                                window.location.href = response.data.redirect;
                            }
                            if (response.data?.message) {
                                if (response.data.success && dialogSuccessElm) {
                                    dialogSuccessElm.querySelector('.dialog__response_title').textContent = response.data.message;
                                    dialogSuccessElm.showModal();
                                } else if (dialogErrorElm) {
                                    dialogErrorElm.querySelector('.dialog__response_title').textContent = response.data.message;
                                    dialogErrorElm.showModal();
                                }
                            }

                            if (formElm.id === 'form--profile') {
                                const newName = formData.get('name');

                                if (newName) {
                                    const nameInput = formElm.querySelector('[name="name"]');
                                    if (nameInput) nameInput.value = newName;

                                    const initialEl = document.getElementById('profile-initial');
                                    if (initialEl) initialEl.textContent = newName.trim().charAt(0).toUpperCase();

                                    const greetingTextEl = document.getElementById('profile-greeting-text');
                                    if (greetingTextEl) {
                                        const greetingPrefix = greetingTextEl.textContent.split(',')[0];
                                        greetingTextEl.textContent = `${greetingPrefix}, ${newName}`;
                                    }
                                }

                                const phoneInput = formElm.querySelector('[name="phone"]');
                                if (phoneInput && formData.get('phone') !== null) {
                                    phoneInput.value = formData.get('phone');
                                }

                                const checkbox = formElm.querySelector('input[name="notifications"]');
                                if (checkbox) {
                                    checkbox.checked = formData.get('notifications') !== null;
                                }
                            } else {
                                formElm.reset();
                                resetCustomSelects();
                            }

                            formItemElms.forEach(item => item.classList.remove('is--filled', 'has--error'));

                            formSubmitBtn?.classList.remove('button--loading');
                        }, 60);
                    } else {

                        if (dialogErrorElm) {
                            closeAllDialogs();
                            dialogErrorElm.querySelector('.dialog__response_title').textContent = response.data.message;
                            dialogErrorElm.showModal();
                        }
                        formSubmitBtn?.classList.remove('button--loading');
                    }
                } catch (error) {
                    const status = error?.response?.status;

                    if (status === 422 && error.response?.data?.errors) {
                        renderFormErrors(error, formElm);
                    } else if (dialogErrorElm) {
                        const message =
                            error?.response?.data?.message ??
                            'Something went wrong';

                        closeAllDialogs();

                        dialogErrorElm
                            .querySelector('.dialog__response_title')
                            .textContent = message;

                        dialogErrorElm.showModal();
                    }

                    formSubmitBtn?.classList.remove('button--loading');
                }
            }
        });
    }
}

export default initFormsSubmit;
